<div class="d-flex card">
	<div class="d-flex">
		<div class="display-6 ms-1 mt-2 mb-1">Webhooks</div>
		<div class="ms-auto">
			<app-record-control-footer
				[hideAdd]="false"
				[hideCancel]="true"
				[hideDelete]="true"
				[hideSave]="true"
				(onAddChange)="addWebhook()"
			></app-record-control-footer>
		</div>
	</div>
	<p-divider></p-divider>
	<p-table
		#dt
		styleClass="p-datatable-responsive-demo"
		[value]="webhookSubscriptions"
		[loading]="!webhookSubscriptions"
		[globalFilterFields]="app.keys(webhookSubscriptions)"
		[scrollable]="true"
		[rows]="100"
		scrollHeight="700px"
		[virtualScroll]="true"
		[virtualRowHeight]="40"
	>
		<ng-template pTemplate="caption">
			<div class="table-header d-flex">
				<div class="flex-grow-1">
					<span class="p-float-label p-input-icon-left m-2 w-100">
						<i class="pi pi-search"></i>
						<input
							pInputText
							class="w-100"
							id="globalSearch"
							name="globalSearch"
							style="width: 100%"
							type="text"
							(input)="dt.filterGlobal($event.target.value, 'contains')"
						/>
						<label for="globalSearch">Search...</label>
					</span>
				</div>
			</div>
		</ng-template>
		<ng-template pTemplate="header">
			<tr>
				<th pSortableColumn="checkNumber">
					<div class="d-flex w-100">
						Integrator
						<p-sortIcon field="integrator.name"></p-sortIcon>
						<div class="ms-auto">
							<p-columnFilter type="text" field="integrator.name" display="menu" class="ms-auto"></p-columnFilter>
						</div>
					</div>
				</th>
				<th pSortableColumn="checkNumber">
					<div class="d-flex w-100">
						Webhook
						<p-sortIcon field="Webhook?.name"></p-sortIcon>
						<div class="ms-auto">
							<p-columnFilter type="text" field="Webhook?.name" display="menu" class="ms-auto"></p-columnFilter>
						</div>
					</div>
				</th>
				<th pSortableColumn="checkNumber">
					<div class="d-flex w-100">
						URL
						<p-sortIcon field="WebhookUrl"></p-sortIcon>
						<div class="ms-auto">
							<p-columnFilter type="text" field="WebhookUrl" display="menu" class="ms-auto"></p-columnFilter>
						</div>
					</div>
				</th>
				<th pSortableColumn="checkNumber">
					<div class="d-flex w-100">
						Successes
						<p-sortIcon field="Successes"></p-sortIcon>
						<div class="ms-auto">
							<p-columnFilter type="number" field="Successes" display="menu" class="ms-auto"></p-columnFilter>
						</div>
					</div>
				</th>
				<th pSortableColumn="checkNumber">
					<div class="d-flex w-100">
						Failures
						<p-sortIcon field="Failures"></p-sortIcon>
						<div class="ms-auto">
							<p-columnFilter type="number" field="Failures" display="menu" class="ms-auto"></p-columnFilter>
						</div>
					</div>
				</th>
			</tr>
		</ng-template>
		<ng-template let-rec pTemplate="body">
			<tr>
				<td>
					{{ rec.integrator?.name }}
				</td>
				<td>
					{{ rec.Webhook?.Name }}
				</td>
				<td>
					{{ rec.WebhookUrl }}
				</td>
				<td>{{ rec.Successes || 0 }} ({{ app.moment(rec.LastSuccess).fromNow() }})</td>
				<td>{{ rec.Failures || 0 }} ({{ app.moment(rec.LastFailure).fromNow() }})</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<app-webhook-record
	*ngIf="webhookSelected"
	[(integratorList)]="venueIntegrators"
	[(webhookSelected)]="webhookSelected"
	(webhookDeleteChange)="delete($event)"
></app-webhook-record>
